/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react'
import { Radio, Icon, Button, Header, Form, Modal } from 'semantic-ui-react'
import TimePicker from 'rc-time-picker'
import moment from 'moment'
import _ from 'lodash'

export default class CategorySectionForm extends React.PureComponent {
  btnSubmitRef = React.createRef()

  state = {
    scheduleType: 'custom',
    // eslint-disable-next-line react/no-unused-state
    // eslint-disable-next-line react/destructuring-assignment
    initTimeFrame: this.props.formSectionData.time_frame,
  }

  onSave = e => {
    const { saveSection } = this.props
    e.preventDefault()

    saveSection()
  }

  onDateChange = (field, value) => {
    const { onFieldChange } = this.props
    let newValue

    if (field === 'expired_at') {
      newValue = moment(value)
        .endOf('day')
        .format('x')
    } else {
      newValue = moment(value)
        .startOf('day')
        .format('x')
    }

    onFieldChange(field, Number(newValue))
  }

  onScheduleTypeChange = (e, { value }) => {
    const { onFieldChange } = this.props
    const { initTimeFrame } = this.state

    this.setState({ scheduleType: value }, () => {
      onFieldChange('schedules', initTimeFrame)
    })
  }

  onScheduleChange = (day, fromOrTo, time) => {
    const { onFieldChange } = this.props
    const { formSectionData } = this.props
    let timeFrame = formSectionData.time_frame

    let formattedTime = {}

    if (time) {
      formattedTime = time.format('HH:mm')
    } else {
      return
    }

    if (day !== 'all') {
      timeFrame = {
        ...timeFrame,
        [day]: {
          ...timeFrame[day],
          [fromOrTo]: formattedTime,
        },
      }

      onFieldChange('time_frame', timeFrame)
    } else {
      let newSchedules = timeFrame

      _.forEach(timeFrame, (schedule, scheduleDay) => {
        newSchedules = {
          ...newSchedules,
          [scheduleDay]: {
            ...newSchedules[scheduleDay],
            [fromOrTo]: formattedTime,
          },
        }
      })

      onFieldChange('time_frame', newSchedules)
    }
  }

  serializeCategories = () => {
    const { categoriesData, selectedCategories } = this.props
    const options = []

    _.forEach(selectedCategories, (category, key) =>
      options.push({
        key,
        value: key,
        text: categoriesData[key],
      })
    )

    if (_.size(options) > 0) {
      options.push({ key: 'unselect', value: '@unselect', text: 'Unselect' })
    }

    return options
  }

  onCategoryChange = (e, { value }) => {
    const { onFieldChange } = this.props

    if (value === '@unselect') {
      onFieldChange('category', '')
    } else {
      onFieldChange('category', value)
    }
  }

  renderOneForAllDays = () => {
    const { formSectionData } = this.props

    const workingHour = formSectionData.time_frame.monday

    return this.renderTimePicker('From', 'all', workingHour)
  }

  renderAllDays = () => {
    const { formSectionData } = this.props

    return (
      <React.Fragment>
        {this.renderTimePicker('Monday', 'monday', formSectionData.time_frame.monday)}
        {this.renderTimePicker('Tuesday', 'tuesday', formSectionData.time_frame.tuesday)}
        {this.renderTimePicker('Wednesday', 'wednesday', formSectionData.time_frame.wednesday)}
        {this.renderTimePicker('Thursday', 'thursday', formSectionData.time_frame.thursday)}
        {this.renderTimePicker('Friday', 'friday', formSectionData.time_frame.friday)}
        {this.renderTimePicker('Saturday', 'saturday', formSectionData.time_frame.saturday)}
        {this.renderTimePicker('Sunday', 'sunday', formSectionData.time_frame.sunday)}
      </React.Fragment>
    )
  }

  renderTimePicker = (label, day, workingHour) => {
    return (
      <Form.Group inline>
        <label style={{ width: 80, marginRight: 0 }}>{label}</label>
        <TimePicker
          showSecond={false}
          value={moment(workingHour.from, 'HH:mm')}
          onChange={value => this.onScheduleChange(day, 'from', value)}
          format="h:mm a"
          use12Hours
          inputReadOnly
        />

        <label style={{ marginLeft: 10, marginRight: 10 }}>To</label>
        <TimePicker
          showSecond={false}
          value={moment(workingHour.to, 'HH:mm')}
          onChange={value => this.onScheduleChange(day, 'to', value)}
          format="h:mm a"
          use12Hours
          inputReadOnly
        />
      </Form.Group>
    )
  }

  render() {
    const { action, onRemove, onFieldChange, onClose, saving, formSectionData } = this.props
    const { scheduleType } = this.state

    const startAt = moment(formSectionData.started_at).format('YYYY-MM-DD')
    const endAt = moment(formSectionData.expired_at).format('YYYY-MM-DD')

    return (
      <Modal open size="small" style={{ marginTop: 0 }}>
        <Header content="Category Section" />
        <Modal.Content style={{ maxHeight: 500, overflow: 'auto' }} className="branch-form">
          <Form
            onSubmit={this.onSave}
            ref={ref => {
              this.formRef = ref
            }}
            disabled={saving}
          >
            <Form.Group widths="equal">
              <Form.Dropdown
                label="Category"
                placeholder="Please Choose Category"
                fluid
                search
                selection
                disabled={action === 'edit'}
                value={formSectionData.category}
                options={this.serializeCategories()}
                onChange={this.onCategoryChange}
                ref={ref => {
                  this.dropdownRef = ref
                }}
                required
              />
            </Form.Group>
            <Form.Group widths="equal">
              <Form.Input
                fluid
                label="Title"
                placeholder="e.g Boost The Day"
                required
                value={formSectionData.title}
                onChange={e => onFieldChange('title', e.target.value)}
              />
            </Form.Group>
            <Form.Group widths="equal">
              <Form.Input
                fluid
                label="Start At"
                required
                type="date"
                value={startAt}
                onChange={e => this.onDateChange('started_at', e.target.value)}
              />
            </Form.Group>
            <Form.Group widths="equal">
              <Form.Input
                fluid
                label="Expire At"
                required
                type="date"
                value={endAt}
                onChange={e => this.onDateChange('expired_at', e.target.value)}
              />
            </Form.Group>
            <div style={{ height: 10 }} />
            <Form.Group>
              <Form.Field>
                <label>Time Frame</label>
                <Radio
                  label="All Day"
                  name="radioGroup"
                  value="all"
                  checked={scheduleType === 'all'}
                  onChange={this.onScheduleTypeChange}
                  style={{ marginRight: 10 }}
                />
                <Radio
                  label="Custom"
                  name="radioGroup"
                  value="custom"
                  checked={scheduleType === 'custom'}
                  onChange={this.onScheduleTypeChange}
                />
              </Form.Field>
            </Form.Group>
            {scheduleType === 'all' ? this.renderOneForAllDays() : this.renderAllDays()}
            <button
              type="submit"
              hidden
              ref={ref => {
                this.btnSubmitRef = ref
              }}
            />
          </Form>
        </Modal.Content>
        <Modal.Actions>
          {action === 'edit' ? (
            <Button onClick={onRemove} color="red" disabled={saving}>
              Remove
            </Button>
          ) : null}
          <Button onClick={onClose} disabled={saving}>
            Close
          </Button>
          <Button
            icon
            color="black"
            onClick={() => this.btnSubmitRef.click()}
            loading={saving}
            disabled={saving}
          >
            <Icon name="checkmark" /> Save
          </Button>
        </Modal.Actions>
      </Modal>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/category/components/CategorySectionForm.js